import "./index.css";

import { Construction } from "~/shared/components/construction/construction.tsx";

// import { ColorModeSelector } from "@tql/ui-components-react/tql/custom/color-mode/beta";

export const Settings = () => {
	return (
		<div id={"settings-wrapper"}>
			<div className={"color-mode-wrapper"} data-testid={"color-mode-selector"}>
				{/* <ColorModeSelector /> */}
			</div>
			<Construction />
		</div>
	);
};
